import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { CART, CHECKOUT, FlushListTitle, PRODUCT, PRODUCTDETAILS } from "../../../../Constants/Constants";
import { FlushListSubTitle } from "../../../../Data/UiKits/Lists";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const FlushList = () => {
  return (
    <Col xl="4" md="12">
      <Card>
        <CommonCardHeader title={FlushListTitle} span={FlushListSubTitle} />
        <CardBody>
          <ListGroup flush>
            <ListGroupItem><i className="icofont icofont-arrow-right"> </i>{PRODUCT}</ListGroupItem>
            <ListGroupItem><i className="icofont icofont-arrow-right"> </i>{PRODUCTDETAILS}</ListGroupItem>
            <ListGroupItem><i className="icofont icofont-arrow-right"> </i>{CART}</ListGroupItem>
            <ListGroupItem><i className="icofont icofont-arrow-right"> </i>{CHECKOUT}</ListGroupItem>
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default FlushList;
